/**
 * Queries du panneau de recherche global (site public).
 *
 * Couche 2a (ADR-001) au-dessus de `~/services/api/rechercheApi` (fonctions
 * pures qui prennent l'URL de base). Les listes paginées de /recherche vivent
 * dans `useRechercheData` ; ici, seulement ce que le PANNEAU consomme.
 */
import { computed, toValue, type MaybeRefOrGetter, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import {
  fetchComptesThemes,
  type RayonThemes,
} from "~/services/api/rechercheApi";

export const rechercheKeys = {
  comptesThemes: (rayon: RayonThemes) =>
    ["recherche", "comptes-themes", rayon] as const,
};

/**
 * Nombre de résultats par thème dans un rayon (vignettes du panneau) :
 * chargé à l'ouverture du panneau seulement (`enabled`), gardé 5 min.
 */
export function useComptesThemes(params: {
  rayon: MaybeRefOrGetter<RayonThemes>;
  enabled: Ref<boolean>;
}) {
  const apiBaseUrl =
    useRuntimeConfig().public.apiBaseUrl || "https://api.donoor.org";

  return useQuery({
    queryKey: computed(() => rechercheKeys.comptesThemes(toValue(params.rayon))),
    queryFn: ({ signal }) =>
      fetchComptesThemes({
        baseUrl: apiBaseUrl,
        rayon: toValue(params.rayon),
        signal,
      }),
    enabled: params.enabled,
    staleTime: 5 * 60_000,
  });
}
